import Axios from "axios";

export const SelectSumCharge = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/ChargeSum?coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "SUMCHARGE_SELECT", payload: response.data });
    });
  };
};
